import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import {
  SerializerFactory1qv9hivitncuv as SerializerFactory,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { ArrayListSerializer7k5wnrulb3y6 as ArrayListSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/CollectionSerializers.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { get_nullable197rfua9r7fsz as get_nullable } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.services.database.ListChange', null, 3);
        tmp0_serialDesc.addElement_5pzumi_k$('wholeList', true);
        tmp0_serialDesc.addElement_5pzumi_k$('old', true);
        tmp0_serialDesc.addElement_5pzumi_k$('new', true);
        this.$cachedDescriptor_1 = tmp0_serialDesc;
      }
      serializer_qelnde_k$(typeSerial0) {
        return $serializer().new_com_lightningkite_services_database_ListChange_$serializer_usdz0r_k$(typeSerial0);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_qelnde_k$(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        return new.target.new_com_lightningkite_services_database_ListChange_$serializer_mw8ek5_k$();
      }
      static new_com_lightningkite_services_database_ListChange_$serializer_mw8ek5_k$() {
        var $this = createThis(this);
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.services.database.ListChange', $this, 3);
        tmp0_serialDesc.addElement_5pzumi_k$('wholeList', true);
        tmp0_serialDesc.addElement_5pzumi_k$('old', true);
        tmp0_serialDesc.addElement_5pzumi_k$('new', true);
        $this.descriptor_1 = tmp0_serialDesc;
        return $this;
      }
      serialize_dfogp8_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 0) ? true : !(value.wholeList_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 0, new (ArrayListSerializer())(this.typeSerial0__1), value.wholeList_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 1) ? true : !(value.old_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 1, this.typeSerial0__1, value.old_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 2) ? true : !(value.new_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 2, this.typeSerial0__1, value.new_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_dfogp8_k$(encoder, value instanceof ListChange() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp7_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp7_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 0, new (ArrayListSerializer())(this.typeSerial0__1), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp7_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 1, this.typeSerial0__1, tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp7_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 2, this.typeSerial0__1, tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp7_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp7_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 0, new (ArrayListSerializer())(this.typeSerial0__1), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp7_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 1, this.typeSerial0__1, tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp7_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 2, this.typeSerial0__1, tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp7_input.endStructure_1xqz0n_k$(tmp0_desc);
        return ListChange().new_com_lightningkite_services_database_ListChange_ygikrl_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [get_nullable(new (ArrayListSerializer())(this.typeSerial0__1)), get_nullable(this.typeSerial0__1), get_nullable(this.typeSerial0__1)];
      }
      typeParametersSerializers_fr94fx_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [this.typeSerial0__1];
      }
      static new_com_lightningkite_services_database_ListChange_$serializer_usdz0r_k$(typeSerial0) {
        var $this = this.new_com_lightningkite_services_database_ListChange_$serializer_mw8ek5_k$();
        $this.typeSerial0__1 = typeSerial0;
        return $this;
      }
    }
    initMetadataForClass($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var ListChangeClass;
function ListChange() {
  if (ListChangeClass === VOID) {
    class $ {
      constructor(wholeList, old, new_0) {
        Companion_getInstance();
        wholeList = wholeList === VOID ? null : wholeList;
        old = old === VOID ? null : old;
        new_0 = new_0 === VOID ? null : new_0;
        this.wholeList_1 = wholeList;
        this.old_1 = old;
        this.new_1 = new_0;
      }
      toString() {
        return 'ListChange(wholeList=' + toString(this.wholeList_1) + ', old=' + toString(this.old_1) + ', new=' + toString(this.new_1) + ')';
      }
      hashCode() {
        var result = this.wholeList_1 == null ? 0 : hashCode(this.wholeList_1);
        result = imul(result, 31) + (this.old_1 == null ? 0 : hashCode(this.old_1)) | 0;
        result = imul(result, 31) + (this.new_1 == null ? 0 : hashCode(this.new_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ListChange()))
          return false;
        if (!equals(this.wholeList_1, other.wholeList_1))
          return false;
        if (!equals(this.old_1, other.old_1))
          return false;
        if (!equals(this.new_1, other.new_1))
          return false;
        return true;
      }
      static new_com_lightningkite_services_database_ListChange_ygikrl_k$(seen0, wholeList, old, new_0, serializationConstructorMarker) {
        Companion_getInstance();
        if (!(0 === (0 & seen0))) {
          throwMissingFieldException(seen0, 0, Companion_getInstance().$cachedDescriptor_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.wholeList_1 = null;
        else
          $this.wholeList_1 = wholeList;
        if (0 === (seen0 & 2))
          $this.old_1 = null;
        else
          $this.old_1 = old;
        if (0 === (seen0 & 4))
          $this.new_1 = null;
        else
          $this.new_1 = new_0;
        return $this;
      }
    }
    initMetadataForClass($, 'ListChange', ListChange, VOID, VOID, VOID, VOID, {0: Companion_getInstance});
    ListChangeClass = $;
  }
  return ListChangeClass;
}
//region block: exports
export {
  Companion_getInstance as Companion_getInstance20kj6uotbl2x7,
};
//endregion

//# sourceMappingURL=ListChange.mjs.map
